import React from 'react';

export const InputGroupContext = React.createContext({});
